import { render, staticRenderFns } from "./FinalizarAtestado.vue?vue&type=template&id=66625489&"
import script from "./FinalizarAtestado.vue?vue&type=script&lang=js&"
export * from "./FinalizarAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports